import useReportPage from "./hooks/useReportPage";
import Page from "../../components/Page";

const ReportPage = () => {
  const page = useReportPage();
  return <Page {...page} />;
};

export default ReportPage;
